// @ts-check
import { initSchema } from '@aws-amplify/datastore';
import { schema } from './schema';

const LangflowStatus = {
  "SUCCESS": "SUCCESS",
  "ERROR": "ERROR",
  "INFO": "INFO"
};

const AttachedFileEntityType = {
  "DOCUMENT_VERSION": "DOCUMENT_VERSION",
  "EMAIL_TEMPLATE": "EMAIL_TEMPLATE"
};

const TenantLogoVariance = {
  "PRIMARY": "PRIMARY",
  "HUB": "HUB"
};

const UserStatus = {
  "ACTIVE": "ACTIVE",
  "DEACTIVATED": "DEACTIVATED"
};

const InputEngineType = {
  "MULTICATEGORICAL": "MULTICATEGORICAL",
  "SINGLECATEGORICAL": "SINGLECATEGORICAL"
};

const TenantFormTargetType = {
  "API": "API"
};

const TenantFormStatus = {
  "ACTIVE": "ACTIVE",
  "INACTIVE": "INACTIVE"
};

const UserRole = {
  "ALUCIO_ADMIN": "AlucioAdmin",
  "TENANT_ADMIN": "TenantAdmin",
  "TENANT_PUBLISHER": "TenantPublisher",
  "TENANT_VIEWER": "TenantViewer",
  "TENANT_VIEW_ONLY": "TenantViewOnly",
  "TEAM_REPORT_VIEWER": "TeamReportViewer",
  "LEAD_VIEWER": "LeadViewer"
};

const Frequency = {
  "DAILY": "DAILY",
  "WEEKLY": "WEEKLY",
  "MONTHLY": "MONTHLY"
};

const NamedFilterType = {
  "SEARCH_QA_HARD_FILTER": "SEARCH_QA_HARD_FILTER",
  "SEARCH_QA_PRIORITY_DOCS": "SEARCH_QA_PRIORITY_DOCS",
  "SEARCH_QA_MESSAGING_DOCS": "SEARCH_QA_MESSAGING_DOCS"
};

const EmailReportType = {
  "DOCUMENT_UPDATE_NOTIFICATION": "DOCUMENT_UPDATE_NOTIFICATION",
  "ALL_DOCUMENTS_VIEWED": "ALL_DOCUMENTS_VIEWED",
  "DOCUMENT_EXPIRATION_ALERTS": "DOCUMENT_EXPIRATION_ALERTS"
};

const TenantStatus = {
  "ACTIVE": "ACTIVE",
  "INACTIVE": "INACTIVE",
  "PURGED": "PURGED"
};

const StandaloneFormUsage = {
  "STANDALONE": "STANDALONE",
  "MEETINGS": "MEETINGS"
};

const CrmIntegrationType = {
  "SALESFORCE": "SALESFORCE",
  "VEEVA": "VEEVA",
  "VEEVA_VAULT": "VEEVA_VAULT"
};

const FieldDataType = {
  "CATEGORICAL": "CATEGORICAL",
  "MULTICATEGORICAL": "MULTICATEGORICAL",
  "STRING": "STRING",
  "DATE": "DATE",
  "USER_LIST": "USER_LIST",
  "OBJECT": "OBJECT",
  "NUMBER": "NUMBER"
};

const NotificationScope = {
  "NONE": "NONE",
  "EMAIL": "EMAIL",
  "EMAIL_IMMEDIATE": "EMAIL_IMMEDIATE",
  "EMAIL_IMMEDIATE_WITHDRAWN": "EMAIL_IMMEDIATE_WITHDRAWN"
};

const SyncScope = {
  "PUBLISHER": "PUBLISHER",
  "VIEWER": "VIEWER",
  "NONE": "NONE"
};

const DocumentVersionChangeType = {
  "MAJOR": "MAJOR",
  "MINOR": "MINOR"
};

const MappingStatus = {
  "HAS_MAPPINGS": "HAS_MAPPINGS",
  "NO_MAPPINGS": "NO_MAPPINGS"
};

const PageGroupSource = {
  "USER": "USER",
  "DOCUMENT": "DOCUMENT"
};

const AssociatedFileStatus = {
  "ACTIVE": "ACTIVE",
  "DELETED": "DELETED"
};

const AssociatedFileType = {
  "DOCUMENT": "DOCUMENT",
  "ATTACHED_FILE": "ATTACHED_FILE"
};

const FileType = {
  "JPG": "JPG",
  "JPEG": "JPEG",
  "XLS": "XLS",
  "XLSX": "XLSX",
  "XLSM": "XLSM",
  "DOC": "DOC",
  "DOCX": "DOCX",
  "PDF": "PDF",
  "PPTX": "PPTX",
  "PNG": "PNG",
  "MP4": "MP4",
  "WEB": "WEB",
  "HTML": "HTML",
  "ZIP": "ZIP"
};

const DocumentAccessLevel = {
  "TENANT": "TENANT",
  "USER": "USER"
};

const EmailTemplateStatus = {
  "DRAFT": "DRAFT",
  "ACTIVE": "ACTIVE",
  "DEACTIVATED": "DEACTIVATED",
  "REMOVED": "REMOVED"
};

const UserNotationsType = {
  "DOCUMENT_VERSION": "DOCUMENT_VERSION",
  "CUSTOM_DECK": "CUSTOM_DECK"
};

const UserNotationsStatus = {
  "ACTIVE": "ACTIVE",
  "DELETED": "DELETED"
};

const ConversionStatus = {
  "PENDING": "PENDING",
  "PROCESSING": "PROCESSING",
  "PROCESSED": "PROCESSED",
  "ERROR": "ERROR"
};

const EmailTemplateType = {
  "HTML": "HTML",
  "PLAIN_TEXT": "PLAIN_TEXT"
};

const PurposeType = {
  "INTERNAL_USE_ONLY": "INTERNAL_USE_ONLY",
  "EXTERNAL_PROACTIVE": "EXTERNAL_PROACTIVE",
  "EXTERNAL_REACTIVE": "EXTERNAL_REACTIVE",
  "NOT_DEFINED": "NOT_DEFINED"
};

const DocumentStatus = {
  "ARCHIVED": "ARCHIVED",
  "REVOKED": "REVOKED",
  "NOT_PUBLISHED": "NOT_PUBLISHED",
  "PUBLISHED": "PUBLISHED",
  "DELETED": "DELETED",
  "ARCHIVED_WITH_VERSIONS": "ARCHIVED_WITH_VERSIONS",
  "REVOKED_WITH_VERSIONS": "REVOKED_WITH_VERSIONS",
  "DELETED_WITH_VERSIONS": "DELETED_WITH_VERSIONS"
};

const ShareStatus = {
  "IS_SHARED": "IS_SHARED",
  "NOT_SHARED": "NOT_SHARED"
};

const PermissionType = {
  "VIEW": "VIEW",
  "EDIT": "EDIT"
};

const ShareTargetType = {
  "USER": "USER",
  "FILTER": "FILTER",
  "ALL": "ALL"
};

const FolderItemType = {
  "FOLDER": "FOLDER",
  "DOCUMENT_VERSION": "DOCUMENT_VERSION",
  "CUSTOM_DECK": "CUSTOM_DECK"
};

const FolderItemStatus = {
  "ACTIVE": "ACTIVE",
  "REMOVED": "REMOVED"
};

const FolderStatus = {
  "ACTIVE": "ACTIVE",
  "ARCHIVED": "ARCHIVED",
  "REMOVED": "REMOVED"
};

const ShareNotificationScope = {
  "EMAIL": "EMAIL",
  "NONE": "NONE"
};

const ShareType = {
  "DOCUMENT_VERSION": "DOCUMENT_VERSION",
  "RECORDING": "RECORDING",
  "ATTACHED_FILE": "ATTACHED_FILE",
  "HUB": "HUB",
  "CUSTOM_DECK": "CUSTOM_DECK"
};

const ConversionWarningCode = {
  "PASSWORD_PROTECTED": "PASSWORD_PROTECTED"
};

const IntegrationType = {
  "VEEVA": "VEEVA",
  "BEACON": "BEACON",
  "EXPORT_TO_S3": "EXPORT_TO_S3",
  "NONE": "NONE"
};

const DocumentMappingAction = {
  "LINK": "LINK",
  "UNLINK": "UNLINK"
};

const DocumentMappingStatus = {
  "READY": "READY",
  "SUCCEEDED": "SUCCEEDED",
  "PARTIAL": "PARTIAL",
  "NO_CHANGE": "NO_CHANGE"
};

const LogLevel = {
  "WARNING": "WARNING",
  "ERROR": "ERROR",
  "SUCCESS": "SUCCESS",
  "INFO": "INFO"
};

const IntegrationRunStatus = {
  "RUNNING": "RUNNING",
  "COMPLETED": "COMPLETED",
  "WARNING": "WARNING",
  "ERROR": "ERROR"
};

const ForcePropertyUpdate = {
  "OVERRIDE": "OVERRIDE",
  "POPULATE": "POPULATE"
};

const HubStatus = {
  "ACTIVE": "ACTIVE",
  "DELETED": "DELETED"
};

const HubType = {
  "STANDALONE": "STANDALONE",
  "TEMPLATE_INSTANCE": "TEMPLATE_INSTANCE",
  "TEMPLATE": "TEMPLATE"
};

const HubSectionStatus = {
  "ACTIVE": "ACTIVE",
  "DELETED": "DELETED"
};

const HubSectionType = {
  "TEXTAREA": "TEXTAREA",
  "SHARED_FILES": "SHARED_FILES",
  "TODO_LIST": "TODO_LIST",
  "LINKS": "LINKS"
};

const NotationType = {
  "PAGE_BOOKMARK": "PAGE_BOOKMARK",
  "CALLOUT": "CALLOUT",
  "PAGE_NOTE": "PAGE_NOTE",
  "TEXT_INSERTION": "TEXT_INSERTION"
};

const TodoStatus = {
  "ACTIVE": "ACTIVE",
  "COMPLETED": "COMPLETED",
  "DELETED": "DELETED"
};

const HubSharedFileContentType = {
  "DOCUMENT_VERSION": "DOCUMENT_VERSION"
};

const HubSectionItemStatus = {
  "ACTIVE": "ACTIVE",
  "DELETED": "DELETED"
};

const CrmSyncStatus = {
  "SYNCED": "SYNCED",
  "NOT_SYNCED": "NOT_SYNCED",
  "DELETED": "DELETED"
};

const Sentiment = {
  "POSITIVE": "POSITIVE",
  "NEGATIVE": "NEGATIVE"
};

const ContentPresentedStatus = {
  "ACTIVE": "ACTIVE",
  "DELETED": "DELETED"
};

const MeetingContentType = {
  "CUSTOM_DECK": "CUSTOM_DECK",
  "DOCUMENT_VERSION": "DOCUMENT_VERSION",
  "DOCUMENT_VERSION_GROUP": "DOCUMENT_VERSION_GROUP"
};

const MeetingType = {
  "IN_PERSON": "IN_PERSON",
  "VIRTUAL": "VIRTUAL",
  "MANUAL": "MANUAL"
};

const MeetingStatus = {
  "IN_PROGRESS": "IN_PROGRESS",
  "ENDED_EXIT": "ENDED_EXIT",
  "ENDED_TIMEOUT": "ENDED_TIMEOUT",
  "DELETED": "DELETED",
  "LOCKED": "LOCKED",
  "PLANNED": "PLANNED"
};

const MeetingAttendeeStatus = {
  "ACTIVE": "ACTIVE",
  "REMOVED": "REMOVED"
};

const ObjectRecordStatus = {
  "ACTIVE": "ACTIVE",
  "REMOVED": "REMOVED"
};

const AttendeeType = {
  "PRIMARY": "PRIMARY",
  "SECONDARY": "SECONDARY",
  "CRM_USER": "CRM_USER"
};

const FieldStatus = {
  "DISABLED": "DISABLED",
  "ENABLED": "ENABLED"
};

const ControlType = {
  "SELECT": "SELECT",
  "RADIOLIST": "RADIOLIST",
  "CHECKBOX": "CHECKBOX",
  "CHECKBOXLIST": "CHECKBOXLIST",
  "CRMACCOUNTSEARCHER": "CRMACCOUNTSEARCHER",
  "CRMATTENDEELIST": "CRMATTENDEELIST",
  "INPUT": "INPUT",
  "TEXTAREA": "TEXTAREA",
  "DATEPICKER": "DATEPICKER",
  "USERLIST": "USERLIST",
  "CUSTOM": "CUSTOM",
  "OBJECT": "OBJECT",
  "LABEL": "LABEL",
  "INFO_MESSAGE": "INFO_MESSAGE",
  "DATETIMEPICKER": "DATETIMEPICKER",
  "INPUT_CSV": "INPUT_CSV"
};

const FormatValidation = {
  "EMAIL": "EMAIL",
  "EMAIL_CSV": "EMAIL_CSV"
};

const CustomFieldAction = {
  "ARCHIVE": "ARCHIVE",
  "REVOKE": "REVOKE"
};

const CustomFieldActionSkip = {
  "INTEGRATION": "INTEGRATION"
};

const FieldPosition = {
  "LEFT": "LEFT",
  "RIGHT": "RIGHT"
};

const DateRestriction = {
  "ONLY_FUTURE": "ONLY_FUTURE",
  "ONLY_PAST": "ONLY_PAST"
};

const CustomFieldUsage = {
  "USER_FILTER": "USER_FILTER",
  "MEETING": "MEETING",
  "DOCUMENT": "DOCUMENT",
  "EMAIL_TEMPLATE_FILTER": "EMAIL_TEMPLATE_FILTER",
  "CONTENT_SHARE": "CONTENT_SHARE",
  "HUB": "HUB",
  "TENANT_FORM": "TENANT_FORM"
};

const CustomFormRecordStatus = {
  "ACTIVE": "ACTIVE",
  "LOCKED": "LOCKED",
  "DELETED": "DELETED"
};

const CustomFormRecordRelationshipModel = {
  "MEETING": "MEETING"
};

const CustomFormRecordEntity = {
  "BEACON_TENANT_FORM": "BEACON_TENANT_FORM",
  "CRM_OBJECT": "CRM_OBJECT",
  "SURVEY_TARGET": "SURVEY_TARGET"
};

const PermissionEffect = {
  "ALLOW": "ALLOW",
  "BLOCK": "BLOCK"
};

const ZendeskFeature = {
  "CHAT": "CHAT",
  "SSO": "SSO"
};

const PromptType = {
  "DECK_COMPLIANCE_RULE": "DECK_COMPLIANCE_RULE",
  "TENANT_BACKGROUND": "TENANT_BACKGROUND",
  "AI_SUMMARY_DOC_TYPE": "AI_SUMMARY_DOC_TYPE",
  "AI_SUMMARY_INSTRUCTIONS": "AI_SUMMARY_INSTRUCTIONS",
  "AI_SEARCH_ABBREVIATIONS": "AI_SEARCH_ABBREVIATIONS"
};

const PromptStatus = {
  "ACTIVE": "ACTIVE",
  "DELETED": "DELETED"
};

const RelatedSlidePageType = {
  "COVER": "COVER",
  "AGENDA": "AGENDA",
  "CONTENT": "CONTENT",
  "CLINICAL_DATA": "CLINICAL_DATA",
  "SAFETY_INFORMATION": "SAFETY_INFORMATION",
  "BIBLIOGRAPHY": "BIBLIOGRAPHY",
  "APPENDIX": "APPENDIX",
  "OTHER": "OTHER"
};

const BulletinStatus = {
  "DRAFT": "DRAFT",
  "ACTIVE": "ACTIVE",
  "DELETED": "DELETED"
};

const { User, Tenant, UserSettings, DocumentVersion, AttachedFile, Document, EmailTemplate, UserDocumentVersionSettings, UserNotations, CustomDeck, Folder, ContentShare, IntegrationLog, IntegrationSettings, TrainingEvent, Meeting, Hub, CustomFormRecord, PromptValues, Bulletin, VeevaVaultQueryOutput, MantleSummaryDebugModel, MantleSummaryDebugQuote, MantleSummaryDebugResult, MantleSummaryDebugSaveResult, VeevaVaultUpsertObjectsOutput, VeevaVaultObjectMetadataLayouts, VeevaVaultPicklistsItemsOutput, VeevaVaultLookupOutput, VeevaVaultLoginOutput, VeevaAuthenticatedUser, CsvExportNotification, LangflowResponse, RecordAccessedCount, MostAccessedRecords, MostAccessedRecordsWrapper, MostAccessedRecordsOutput, ContentTokenOutput, PresentableContentMetadata, HubAndContentDetails, TenantColor, TenantCustomStyle, TenantConfig, NamedFilter, FieldLabelAndValueIds, EmailReportConfig, CustomDeckAcknowledgement, KeyValue, HubConfig, TenantFormTargetParameters, TenantForm, EntityViewedEvent, EntityViewed, AnalyticsFeed, FeatureFlags, CRMIntegration, ExternalOidcSsoConfig, CRMTableDetailContentPresented, CRMStandaloneForm, CRMStandaloneFormParent, CRMAdditionalSettings, CRMAccountToObjectSetting, CRMAccountToObjectFields, CRMTableSetting, CRMChildTableSetting, VeevaSetting, CRMAccountSettings, CRMAddressSettings, CRMDisplaySettings, ListConfig, FieldListConfig, ListSort, SemVer, AiGeneratedDocumentLabel, PageGroup, AssociatedFile, LabelValue, LabelValues, BookmarkedDoc, BookmarkedFolder, EditMutex, PageSettingOverride, CustomDeckGroup, CustomDeckPage, Sheet, ReportGroup, ReportItem, Dashboard, AvailableDashboards, PageSetting, Page, S3Object, SharePermission, FolderItem, CustomDeckDependencies, IntegrationClientConfigurationTuple, DocumentIntegration, DocumentVersionIntegration, DocumentMappingSourceVersion, DocumentMappingPreview, DocumentMappingResult, IntegrationValueMapping, IntegrationFieldMapping, IntegrationLogEntry, PublisherIntegration, TrainingEventUser, SubmitIntegrationResult, UpdateDocVerPageMatchesResult, UpsertVersionContentsResult, CRMMeetingRecordInfo, HubSection, TextareaHubSettings, SharedFileHubSetting, Notation, Coordinate, ToDo, Link, DocumentVersionSettings, HubSharedAssociatedFile, ContentPresented, PresentedMeta, PagePresentedEvent, Attendee, CustomFieldDefinition, ObjectSetting, ObjectRestriction, CommonFieldSettings, DocumentFieldSettings, CustomFormRecordCRMFields, CustomFieldValueDefinition, DocumentFieldValueSettings, DocumentPermission, FieldValue, CustomValues, ObjectRecord, ObjectRecordValue, AccessTokenData, GetDependenciesOutput, FolderPermission, GetSharedFoldersOutput, ZendeskTokenPayload, UserInfoPayload, AuthInformationPayload, RefreshTokenCRMPayload, QuickFilter, FullTextSearchOutput, FullTextSearchResultItem, RelatedSlidesResultItem, RelatedSlidesOutput, TextWithHighlights, Highlights } = initSchema(schema);

export {
  User,
  Tenant,
  UserSettings,
  DocumentVersion,
  AttachedFile,
  Document,
  EmailTemplate,
  UserDocumentVersionSettings,
  UserNotations,
  CustomDeck,
  Folder,
  ContentShare,
  IntegrationLog,
  IntegrationSettings,
  TrainingEvent,
  Meeting,
  Hub,
  CustomFormRecord,
  PromptValues,
  Bulletin,
  LangflowStatus,
  AttachedFileEntityType,
  TenantLogoVariance,
  UserStatus,
  InputEngineType,
  TenantFormTargetType,
  TenantFormStatus,
  UserRole,
  Frequency,
  NamedFilterType,
  EmailReportType,
  TenantStatus,
  StandaloneFormUsage,
  CrmIntegrationType,
  FieldDataType,
  NotificationScope,
  SyncScope,
  DocumentVersionChangeType,
  MappingStatus,
  PageGroupSource,
  AssociatedFileStatus,
  AssociatedFileType,
  FileType,
  DocumentAccessLevel,
  EmailTemplateStatus,
  UserNotationsType,
  UserNotationsStatus,
  ConversionStatus,
  EmailTemplateType,
  PurposeType,
  DocumentStatus,
  ShareStatus,
  PermissionType,
  ShareTargetType,
  FolderItemType,
  FolderItemStatus,
  FolderStatus,
  ShareNotificationScope,
  ShareType,
  ConversionWarningCode,
  IntegrationType,
  DocumentMappingAction,
  DocumentMappingStatus,
  LogLevel,
  IntegrationRunStatus,
  ForcePropertyUpdate,
  HubStatus,
  HubType,
  HubSectionStatus,
  HubSectionType,
  NotationType,
  TodoStatus,
  HubSharedFileContentType,
  HubSectionItemStatus,
  CrmSyncStatus,
  Sentiment,
  ContentPresentedStatus,
  MeetingContentType,
  MeetingType,
  MeetingStatus,
  MeetingAttendeeStatus,
  ObjectRecordStatus,
  AttendeeType,
  FieldStatus,
  ControlType,
  FormatValidation,
  CustomFieldAction,
  CustomFieldActionSkip,
  FieldPosition,
  DateRestriction,
  CustomFieldUsage,
  CustomFormRecordStatus,
  CustomFormRecordRelationshipModel,
  CustomFormRecordEntity,
  PermissionEffect,
  ZendeskFeature,
  PromptType,
  PromptStatus,
  RelatedSlidePageType,
  BulletinStatus,
  VeevaVaultQueryOutput,
  MantleSummaryDebugModel,
  MantleSummaryDebugQuote,
  MantleSummaryDebugResult,
  MantleSummaryDebugSaveResult,
  VeevaVaultUpsertObjectsOutput,
  VeevaVaultObjectMetadataLayouts,
  VeevaVaultPicklistsItemsOutput,
  VeevaVaultLookupOutput,
  VeevaVaultLoginOutput,
  VeevaAuthenticatedUser,
  CsvExportNotification,
  LangflowResponse,
  RecordAccessedCount,
  MostAccessedRecords,
  MostAccessedRecordsWrapper,
  MostAccessedRecordsOutput,
  ContentTokenOutput,
  PresentableContentMetadata,
  HubAndContentDetails,
  TenantColor,
  TenantCustomStyle,
  TenantConfig,
  NamedFilter,
  FieldLabelAndValueIds,
  EmailReportConfig,
  CustomDeckAcknowledgement,
  KeyValue,
  HubConfig,
  TenantFormTargetParameters,
  TenantForm,
  EntityViewedEvent,
  EntityViewed,
  AnalyticsFeed,
  FeatureFlags,
  CRMIntegration,
  ExternalOidcSsoConfig,
  CRMTableDetailContentPresented,
  CRMStandaloneForm,
  CRMStandaloneFormParent,
  CRMAdditionalSettings,
  CRMAccountToObjectSetting,
  CRMAccountToObjectFields,
  CRMTableSetting,
  CRMChildTableSetting,
  VeevaSetting,
  CRMAccountSettings,
  CRMAddressSettings,
  CRMDisplaySettings,
  ListConfig,
  FieldListConfig,
  ListSort,
  SemVer,
  AiGeneratedDocumentLabel,
  PageGroup,
  AssociatedFile,
  LabelValue,
  LabelValues,
  BookmarkedDoc,
  BookmarkedFolder,
  EditMutex,
  PageSettingOverride,
  CustomDeckGroup,
  CustomDeckPage,
  Sheet,
  ReportGroup,
  ReportItem,
  Dashboard,
  AvailableDashboards,
  PageSetting,
  Page,
  S3Object,
  SharePermission,
  FolderItem,
  CustomDeckDependencies,
  IntegrationClientConfigurationTuple,
  DocumentIntegration,
  DocumentVersionIntegration,
  DocumentMappingSourceVersion,
  DocumentMappingPreview,
  DocumentMappingResult,
  IntegrationValueMapping,
  IntegrationFieldMapping,
  IntegrationLogEntry,
  PublisherIntegration,
  TrainingEventUser,
  SubmitIntegrationResult,
  UpdateDocVerPageMatchesResult,
  UpsertVersionContentsResult,
  CRMMeetingRecordInfo,
  HubSection,
  TextareaHubSettings,
  SharedFileHubSetting,
  Notation,
  Coordinate,
  ToDo,
  Link,
  DocumentVersionSettings,
  HubSharedAssociatedFile,
  ContentPresented,
  PresentedMeta,
  PagePresentedEvent,
  Attendee,
  CustomFieldDefinition,
  ObjectSetting,
  ObjectRestriction,
  CommonFieldSettings,
  DocumentFieldSettings,
  CustomFormRecordCRMFields,
  CustomFieldValueDefinition,
  DocumentFieldValueSettings,
  DocumentPermission,
  FieldValue,
  CustomValues,
  ObjectRecord,
  ObjectRecordValue,
  AccessTokenData,
  GetDependenciesOutput,
  FolderPermission,
  GetSharedFoldersOutput,
  ZendeskTokenPayload,
  UserInfoPayload,
  AuthInformationPayload,
  RefreshTokenCRMPayload,
  QuickFilter,
  FullTextSearchOutput,
  FullTextSearchResultItem,
  RelatedSlidesResultItem,
  RelatedSlidesOutput,
  TextWithHighlights,
  Highlights
};